import _ from "lodash";
import { path } from "../../api";
import { restClient } from "../../utils/restClient";

const initialState = {
  verificationState: null,
  identityVerification: null,
};

export default {
  namespaced: true,
  name: "identityVerification",
  state: _.cloneDeep(initialState),
  mutations: {
    SET_VERIFICATION_STATE(state, payload) {
      state.verificationState = payload;
    },
    SET_IDENTITY_VERIFICATION(state, payload) {
      state.identityVerification = payload;
    },
  },
  actions: {
    async fetchIdentityVerifications(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.identityVerifications.base,
            "GET",
            null,
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    fetchIdentityVerificationById({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.identityVerifications.single(payload),
            "GET"
          );
          commit("SET_IDENTITY_VERIFICATION", response.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async reviewIdentityVerification({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.identityVerifications.review(payload.id),
            "PATCH",
            payload
          );
          commit("SET_IDENTITY_VERIFICATION", response.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async identityVerify(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.identityVerify,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async identityVerifyState({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.identityVerifyState,
            "GET",
            payload
          );
          commit("SET_VERIFICATION_STATE", response.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  getters: {
    getVerificationState: (state) => state.verificationState,
    getIdentityVerification: (state) => state.identityVerification,
  },
};
